import { gql } from '@apollo/client';

export const CREATE_BOOK = gql`
  mutation CreateBook($input: BookInput) {
    createBook(input: $input) {
      id
    }
  }
`;

export const CREATE_BOOK_WITH_PRODUCT = gql`
  mutation CreateBookWithProduct($input: BookInputWithProduct) {
    createBookWithProduct(input: $input) {
      id
    }
  }
`;
